import { useMutation } from '@apollo/client/react';
import { addDays, endOfDay } from 'date-fns';
import { Formik } from 'formik';
import { useResetAtom } from 'jotai/utils';
import React, { useCallback, useEffect } from 'react';

import { Alert, Button, Modal, Select, Text } from '~/components/blocks';
import {
  AllowAccessPermissionDocument,
  GetAccessPermissionDocument,
} from '~/graphql/generated/graphql';
import { permissionModalState } from '~/state/layouts/OrganizationAppShell/atoms';

import { AllowAccessPermissionForm } from './types';
import { validationSchema } from './validation';

const initalValue: AllowAccessPermissionForm = {
  afterDays: 0,
};

export const AllowPane = () => {
  const resetPermissionModalState = useResetAtom(permissionModalState);
  const [allowAccessPermission, { data, error, loading }] = useMutation(
    AllowAccessPermissionDocument,
    {
      refetchQueries: [{ query: GetAccessPermissionDocument }],
    },
  );

  useEffect(() => {
    if (data?.allowOperatorAccessPermission) {
      resetPermissionModalState();
    }
  }, [data, resetPermissionModalState]);
  const handleSubmit = useCallback(
    (values: AllowAccessPermissionForm) => {
      const afterDays = +values.afterDays;
      const afterDate = addDays(new Date(), afterDays);
      const expireDate = endOfDay(afterDate);

      allowAccessPermission({ variables: { input: { expiresAt: expireDate.toISOString() } } });
    },
    [allowAccessPermission],
  );

  return (
    <Formik initialValues={initalValue} validationSchema={validationSchema} onSubmit={handleSubmit}>
      {(formik) => (
        <>
          <Modal.Body>
            {error && <Alert status="error">エラーが発生しました</Alert>}
            <Text>
              MEDIXSかかりつけ支援サポートスタッフに一時的にアクセス権を付与します。アクセスできる期間を選択してください。
            </Text>
            <Select name="afterDays" onChange={formik.handleChange}>
              <option value="0">本日のみ許可する</option>
              <option value="1">明日まで許可する</option>
              <option value="3">3日後まで許可する</option>
              <option value="7">1週間後まで許可する</option>
            </Select>
          </Modal.Body>
          <Modal.Footer>
            <Button use="base" loading={loading} onClick={formik.submitForm}>
              許可
            </Button>
          </Modal.Footer>
        </>
      )}
    </Formik>
  );
};
